import React from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import grantEngineLogoPng from "./assets/Grant Engine Logo Blue.png";
import {
  BsExclamationCircle,
  BsExclamationTriangle,
  BsFiletypePdf,
  BsCalendarCheck,
  BsClock
} from "react-icons/bs";
import { Container, Row, Col } from "react-bootstrap";

export default function TDCReportFormPreview({
  data,
  fastTrack,
  phase1BudgetPeriod,
  onDownloadPDF
}) {
  if (!data) return null;

  

  // URL analysis from backend JSON (url_analysis)
  const urlAnalysis = data.url_analysis;
  const url001 = urlAnalysis?.URL001_PDF_Link_Extraction;
  const url002 = urlAnalysis?.URL002_Embedded_Text_based_URL_Analysis;

  return (
    <div style={{ position: "relative", minHeight: 400, paddingBottom: 80 }}>
      <Container style={{ maxWidth: 800, fontFamily: "Helvetica, Arial, sans-serif" }}>
        {/* Header */}
        <Row className="align-items-center mb-2">
          <Col xs="auto">
            <img
              src={grantEngineLogoPng}
              alt="Grant Engine Logo"
              style={{ height: 36, width: "auto", gap: 8, marginRight: 10 }}
            />
            <div
              className="text-uppercase"
              style={{
                fontWeight: 400,
                letterSpacing: 1,
                fontSize: "18px",
                color: "#000000ff"
              }}
            >
              LLM Analysis
            </div>
          </Col>
        </Row>

        {/* Filename */}
        <Row className="mb-2">
          <Col className="fs-4 fw-bold">{data.filename}</Col>
        </Row>

        {/* Date & Time */}
        <Row className="fs-6 text-secondary mb-2">
          <Col xs="auto" className="d-flex align-items-center">
            <BsCalendarCheck className="me-2" />
            {data.date.split("\n")[0]}
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            <BsClock className="me-2" />
            {data.date.split("\n")[1]}
          </Col>
        </Row>

        <div
          style={{
            borderBottom: "2px solid #ececec",
            marginBottom: 18,
            marginTop: 5
          }}
        />

        {/* Files List */}
        <Row>
          <Col>
            <div className="fw-bold my-1">Files</div>
            {data.files?.map((f) => (
              <div key={f} className="d-flex align-items-center mb-1">
                <BsFiletypePdf
                  style={{ fontSize: "1.2rem", color: "#c62828", marginRight: 8 }}
                />
                <span>{f}</span>
              </div>
            ))}
          </Col>
        </Row>

        <div
          style={{
            borderBottom: "2px solid #ececec",
            marginBottom: 18,
            marginTop: 4
          }}
        />

        {/* Summary Section */}
        <Row className="mb-3">
          <Col xs="auto" className="d-flex align-items-center">
            <BsExclamationCircle
              style={{ color: "#d32f2f", fontSize: "1.35rem", marginRight: 6 }}
            />
            <span className="fw-bold text-danger">
              Required Fixes: {data.required_fixes_count ?? 0}
            </span>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            <BsExclamationTriangle
              style={{ color: "#faad14", fontSize: "1.35rem", marginRight: 6 }}
            />
            <span className="fw-bold" style={{ color: "#faad14" }}>
              PM Discretion: {data.pm_discretion_count ?? 0}
            </span>
          </Col>
        </Row>

        {/* Fast Track + Budget */}
        <div style={{ marginTop: "16px", marginBottom: "8px" }}>
          <div>
            <span style={{ fontWeight: "bold" }}>The application Fast Track: </span>
            <span>{fastTrack === "yes" ? "Yes" : "No"}</span>
          </div>
          {fastTrack === "yes" && (
            <div style={{ marginTop: "4px" }}>
              <span style={{ fontWeight: "bold" }}>
                What are the phase one budget period(s):{" "}
              </span>
              <span>
                {phase1BudgetPeriod.length === 0
                  ? "None"
                  : phase1BudgetPeriod.join(", ")}
              </span>
            </div>
          )}
        </div>

        {/* Required Fixes */}
        <div className="fw-bold fs-5 mt-3 mb-3 d-flex align-items-center">
          <BsExclamationCircle
            style={{ color: "#d32f2f", fontSize: "1.5rem", marginRight: 10 }}
          />
          Required Fixes
        </div>
        {data.required_fixes?.map((fix, i) => (
          <div key={i} className="mb-4">
            <div
              className="fw-bold mb-1 d-flex align-items-center"
              style={{ fontSize: "1.08rem", lineHeight: 1.3 }}
            >
              <BsExclamationCircle
                style={{
                  color: "#d32f2f",
                  fontSize: "1.14rem",
                  marginRight: 8,
                  marginTop: -2
                }}
              />
              {fix.category}
            </div>
            <div
              style={{
                background: "#fbfbfe",
                border: "1.5px solid #e7e9ef",
                borderRadius: 10,
                padding: "16px 18px 13px 18px",
                boxShadow: "0 1px 4px 0 #f5f5f5"
              }}
            >
              <div className="d-flex align-items-start" style={{ marginBottom: 8 }}>
                <Form.Check
                  type="checkbox"
                  id={`checkbox-${fix.id}`}
                  style={{ marginRight: 15, marginTop: 1 }}
                  disabled
                />
                <div
                  style={{
                    fontSize: "0.98rem",
                    color: "#182230",
                    fontWeight: 500,
                    lineHeight: 1.5,
                    flex: 1
                  }}
                >
                  {fix.llm_analysis}
                </div>
              </div>
              <div
                style={{
                  borderBottom: "1px solid #ececec",
                  margin: "0 -18px 13px -18px"
                }}
              />
              <div>
                <FloatingLabel
                  controlId={`reason-${fix.id}`}
                  label="Reason for not addressing"
                >
                  <Form.Control
                    as="textarea"
                    style={{
                      background: "#f7f7f7",
                      height: "60px",
                      fontSize: "1.05rem",
                      fontFamily: "'Times New Roman', Times, serif"
                    }}
                    readOnly
                    disabled
                  />
                </FloatingLabel>
              </div>
            </div>
          </div>
        ))}

        {/* PM Discretion */}
        <div className="fw-bold fs-5 mt-4 mb-3 d-flex align-items-center">
          <BsExclamationTriangle
            style={{ color: "#faad14", fontSize: "1.5rem", marginRight: 10 }}
          />
          PM Discretion
        </div>
        {data.pm_discretion?.map((pm, i) => (
          <div key={i} className="mb-4">
            <div
              className="fw-bold mb-1 d-flex align-items-center"
              style={{ fontSize: "1.08rem", lineHeight: 1.3 }}
            >
              <BsExclamationTriangle
                style={{
                  color: "#faad14",
                  fontSize: "1.14rem",
                  marginRight: 8,
                  marginTop: -2
                }}
              />
              {pm.category}
            </div>
            <div
              style={{
                background: "#fefbf3",
                border: "1.5px solid #f3eacc",
                borderRadius: 10,
                padding: "16px 18px 13px 18px",
                boxShadow: "0 1px 4px 0 #f8eac6"
              }}
            >
              <div className="d-flex align-items-start" style={{ marginBottom: 8 }}>
                <Form.Check
                  type="checkbox"
                  id={`checkbox-pm-${pm.id}`}
                  style={{ marginRight: 15, marginTop: 1 }}
                  disabled
                />
                <div
                  style={{
                    fontSize: "0.98rem",
                    color: "#182230",
                    fontWeight: 500,
                    lineHeight: 1.5,
                    flex: 1
                  }}
                >
                  {pm.llm_analysis}
                </div>
              </div>
              <div
                style={{
                  borderBottom: "1px solid #f6dca2",
                  margin: "0 -18px 13px -18px"
                }}
              />
              <div>
                <FloatingLabel
                  controlId={`reason-pm-${pm.id}`}
                  label="Reason for not addressing"
                >
                  <Form.Control
                    as="textarea"
                    style={{
                      background: "#f8f5e6",
                      height: "60px",
                      fontSize: "1.05rem",
                      fontFamily: "'Times New Roman', Times, serif"
                    }}
                    readOnly
                    disabled
                  />
                </FloatingLabel>
              </div>
            </div>
          </div>
        ))}

                {/* URL Link Analysis from url_analysis */}
        {urlAnalysis && (
          <>
            <div
              style={{
                borderBottom: "2px solid #ececec",
                marginBottom: 18,
                marginTop: 4
              }}
            />

            <div className="fw-bold fs-5 mt-3 mb-2">URL Link Analysis</div>
            <div className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
              Comprehensive analysis of URLs and links found in the application document.
            </div>

            {/* Table 1: PDF Link Extraction */}
            {url001 && (
              <div className="mb-4">
                <div className="fw-bold mb-2" style={{ fontSize: "1.05rem" }}>
                  URL001 - PDF Link Extraction
                </div>
                <div style={{ overflowX: "auto" }}>
                  <table
                    className="table table-sm"
                    style={{ fontSize: "0.85rem", minWidth: 700 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Page</th>
                        <th style={{ width: "15%" }}>Type</th>
                        <th style={{ width: "35%" }}>Text</th>
                        <th style={{ width: "40%" }}>URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(url001.pages || {})
                        .map(Number)
                        .sort((a, b) => a - b)
                        .flatMap((pageNum) => {
                          const entries = url001.pages[String(pageNum)] || [];
                          return entries.map((e, idx) => (
                            <tr key={`${pageNum}-${idx}`}>
                              <td>{pageNum}</td>
                              <td>{e.type || "Text"}</td>
                              <td>{e.text || "(no text)"}</td>
                              <td>
                                {e.url ? (
                                  <a
                                    href={e.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {e.url}
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          ));
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Table 2: Embedded Text-based URL Analysis */}
            {url002 && (
              <div className="mb-4">
                <div className="fw-bold mb-2" style={{ fontSize: "1.05rem" }}>
                  URL002 - Embedded Text-based URL Analysis
                </div>
                <div style={{ overflowX: "auto" }}>
                  <table
                    className="table table-sm"
                    style={{ fontSize: "0.85rem", minWidth: 700 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Page</th>
                        <th style={{ width: "15%" }}>Type</th>
                        <th style={{ width: "35%" }}>Text</th>
                        <th style={{ width: "40%" }}>URL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(url002.pages || {})
                        .map(Number)
                        .sort((a, b) => a - b)
                        .flatMap((pageNum) => {
                          const entries = url002.pages[String(pageNum)] || [];
                          return entries.map((e, idx) => (
                            <tr key={`${pageNum}-${idx}`}>
                              <td>{pageNum}</td>
                              <td>{e.type || "Text"}</td>
                              <td>{e.text || "(no text)"}</td>
                              <td>
                                {e.url ? (
                                  <a
                                    href={e.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {e.url}
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          ));
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}

        
      </Container>
    </div>
  );
}
